import { AxiosPromise } from "axios";
import { apiAdn } from "./common";

export function fetchOneTranslation(key: string): AxiosPromise<string> {
  return apiAdn.get(`/translation?key=${key}`);
}
